module.exports = new Promise(async (resolve, reject) => {
          if (typeof window === 'undefined') return reject(new Error('window is not defined'));
          
          // Check if manifest is already available with federatedApps
          if (!window.__APP_MANIFEST__?.federatedApps) {
            // Try to fetch latest manifest first
            let appManifest = fetch("https://production.app-manifest.leadconnectorhq.com/latest/manifest.json").then(res => {
              return res.json();
            }).catch(async err => {
              console.error("Failed to fetch latest manifest: ", err);
              
              // If latest fails and fallback exists, try fallback
              if ("https://production.app-manifest.leadconnectorhq.com/fallback/manifest.json") {
                console.log("Attempting to fetch fallback manifest...");
                const fallbackRes = await fetch("https://production.app-manifest.leadconnectorhq.com/fallback/manifest.json");
                if (!fallbackRes.ok) throw new Error('Failed to fetch fallback manifest');
                return fallbackRes.json();
              }
              return {}; // fallback is object
            });
            window.__APP_MANIFEST__ = await appManifest;
          }

          const manifest = await window.__APP_MANIFEST__.federatedApps;
          const url = manifest["marketplaceApp"];
          if (!url) return reject(new Error("Remote not found: marketplaceApp"));
  
          const script = document.createElement('script');
          script.src = url;
          script.onload = () => {
            const proxy = {
              get: (request) => window["marketplaceApp"].get(request),
              init: (arg) => {
                try { return window["marketplaceApp"].init(arg); } catch (_) {}
              }
            };
            resolve(proxy);
          };
          script.onerror = () => reject(new Error("Failed to load remote: " + url));
          document.head.appendChild(script);
        });